import { useProfile } from 'context/profile';
import useInvalidateQueries from 'hooks/useInvalidateQueries';
import { useWebsocketSubscription } from 'hooks/useWebsocketSubscription';
import { LOCATION_EPISODE_CHANNEL } from 'services/api/constants';

type LocationEpisodeChannelMessage = {
  activities?: boolean;
  locationEpisodeRehabStates?: boolean;
  actorId: string;
};

export function useLocationEpisodeLiveUpdates({
  locationEpisodeId,
  episodeId,
}: {
  locationEpisodeId?: string;
  episodeId?: string;
}) {
  const { profile } = useProfile();
  const invalidateQueries = useInvalidateQueries();

  useWebsocketSubscription<LocationEpisodeChannelMessage>({
    channel: LOCATION_EPISODE_CHANNEL,
    params: { location_episode_id: locationEpisodeId },
    onReceived: (data) => {
      if (data.actorId === profile.id) return;

      if (data.activities) {
        invalidateQueries({
          activities: true,
          ...(locationEpisodeId && { attachmentsCount: { locationEpisodeId } }),
        });
      }

      // The header's Discharge button reads the episode's rehab state, so a discharge made elsewhere (a PCC auto
      // discharge, another user) must refetch the episode too, or the button stays enabled until a page refresh
      if (data.locationEpisodeRehabStates && locationEpisodeId) {
        invalidateQueries({
          locationEpisode: { id: locationEpisodeId },
          ...(episodeId && { episode: { id: episodeId } }),
        });
      }
    },
    enabled: !!locationEpisodeId,
  });
}
